import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import DialogTitle from '@material-ui/core/DialogTitle';

import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';


import { getUIText } from '../../utils/index';

import { closeLogin } from '../../modules/app';

import { logIn } from '../../modules/user';

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      pass: '',
      errorMsg: null
    };
  }

  logIn() {
    if(this.state.name.length && this.state.pass.length) {
      this.props.onClickLogin(this.state);
      this.setState({name: '', pass: '', errorMsg: null});
    } else {
      // TODO: Show error: Both fields should be set.
      // TODO: Do we need this?
      // this.setState({errorMsg:"Fill both fields."})
    }
  }

  close() {
    this.props.onCloseLogin();
    this.setState({name: '', pass: '', errorMsg: null});
  }

  render() {
    const {
      onCloseLogin,
      translations,
      app,
      open,
      user
    } = this.props;

    const {
      logInProgress,
      logInError,
      logInErrorMsg,

      username
    } = user ? user : {};

    return (
      <Dialog className="project-dropdown-dialog login-container" open={open} onClose={onCloseLogin}>
        <DialogTitle>{getUIText('GENERAL-LOGIN_HEADER', app.language, translations)}</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <FormControl >
                <InputLabel className="label" htmlFor="name-simple" shrink>{getUIText('GENERAL-LOGIN-USERNAME', app.language, translations)}</InputLabel>
                <Input
                  className="input-item"
                  value={this.state.name}
                  inputProps={
                    {
                      placeholder: getUIText('GENERAL-LOGIN-USERNAME', app.language, translations),
                      onKeyDown: ((e)=> {
                        if(e.keyCode === 13) {
                          this.logIn();
                        }
                      }).bind(this)
                    }
                  }
                  onChange={(e) => {this.setState({'name': e.currentTarget.value});}} />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl >
                <InputLabel className="label" htmlFor="name-simple" shrink>{getUIText('GENERAL-LOGIN-PASSWORD', app.language, translations)}</InputLabel>
                <Input
                  type="password"
                  className="input-item"
                  value={this.state.pass}
                  inputProps={
                    {
                      placeholder: getUIText('GENERAL-LOGIN-PASSWORD', app.language, translations),
                      onKeyDown: ((e)=> {
                        if(e.keyCode === 13) {
                          this.logIn();
                        }
                      }).bind(this)
                    }
                  }
                  onChange={(e) => {this.setState({'pass': e.currentTarget.value});}} />
              </FormControl>
            </Grid>
            { logInError &&
              <Grid item xs={12}>
                <div className="error-message">{logInErrorMsg}</div>
              </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={this.close.bind(this)} >
            {getUIText('GENERAL-CANCEL', app.language, translations)}
          </Button>
          { username ||
            <Button color="primary" autoFocus onClick={this.logIn.bind(this)} >
              {getUIText('GENERAL-LOG_IN', app.language, translations)}
            </Button>
          }
        </DialogActions>
        { logInProgress &&
          <div className="logging-in">
            <div className="item">
              <img width="30px" src="images/loader-anim.gif" />
            </div>
          </div>
        }
      </Dialog>
    );
  }
}

Login.propTypes = {
    user: PropTypes.object,
    app: PropTypes.object,
    project: PropTypes.object,
    translations: PropTypes.object,
  onClickLogin: PropTypes.any,
  onCloseLogin: PropTypes.any,
  open: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      user: state.user,
      app: state.app,
      translations: state.translations,
      project: state.project,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      onCloseLogin: () => dispatch(closeLogin()),
      onClickLogin: (login_information) => dispatch(logIn(login_information)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Login);
